import { i18n } from "./index";
import { FALLBACK } from "./locales";

/**
 * Date and time in the add-in's language. A bare toLocaleString() would follow
 * the browser locale, which is often not the language Outlook runs in.
 */
export function formatDateTime(value: number | string | Date): string {
  return new Date(value).toLocaleString(i18n.language || FALLBACK, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}
